import axios from 'axios';
import qs from 'query-string';
const instance = axios.create();

const find = async ({ newToken, query }) => {
  const { data, headers } = await instance.get(
    `${process.env.REACT_APP_API_URL}/insurances?${qs.stringify(query)}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.insurances,
    total: headers['x-total-count'],
  };
};

const findForExport = async ({ newToken, query }) => {
  const { data, headers } = await instance.get(
    `${process.env.REACT_APP_API_URL}/insurances/export?${qs.stringify(query)}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.insurances,
    total: headers['x-total-count'],
  };
};

const findAdmin = async ({ newToken, query }) => {
  const { data, headers } = await instance.get(
    `${process.env.REACT_APP_API_URL}/insurances/admin?${qs.stringify(query)}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.insurances,
    total: headers['x-total-count'],
  };
};

const findForExportAdmin = async ({ newToken, query }) => {
  const { data, headers } = await instance.get(
    `${process.env.REACT_APP_API_URL}/insurances/admin/export?${qs.stringify(
      query
    )}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.insurances,
    total: headers['x-total-count'],
  };
};

export const importInsurances = async ({ newToken, file }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/insurances/import`,
      data: file,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

const findUserInsurances = async ({ newToken, query, userId }) => {
  const { data, headers } = await instance.get(
    `${process.env.REACT_APP_API_URL}/insurances/admin/${userId}?${qs.stringify(
      query
    )}`,
    {
      headers: {
        Authorization: newToken,
      },
    }
  );

  return {
    data: data.insurances,
    total: headers['x-total-count'],
  };
};

const insurancesAPIs = {
  find,
  findForExport,
  importInsurances,
  findUserInsurances,
  findAdmin,
  findForExportAdmin,
};

export default insurancesAPIs;
